"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _constants = require("../../utils/constants");

var _constants2 = _interopRequireDefault(_constants);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BotManagerController = function () {
  function BotManagerController(BotManagerService, FilterService, $scope) {
    "ngInject";

    (0, _classCallCheck3.default)(this, BotManagerController);
    this.botManagerService = BotManagerService;
    this.filterService = FilterService;
    this.$scope = $scope;
    this.gridOptions = this.getGridOptions();
  }

  (0, _createClass3.default)(BotManagerController, [{
    key: "$onInit",
    value: function $onInit() {
      this.botFlowTestStatusOptions = {
        dataSource: [{ value: 0, text: "Inactive" }],
        dataTextField: "text",
        dataValueField: "value"
      };

      this.botFlowLiveStatusOptions = {
        dataSource: [{ value: 0, text: "Inactive" },
        // { value: 1, text: "Test" },
        { value: 2, text: "Live" }],
        dataTextField: "text",
        dataValueField: "value"
      };
    }
  }, {
    key: "getGridOptions",
    value: function getGridOptions() {
      var _this = this;

      return {
        dataSource: this.botManagerService.getDataSource(this.dataSourceFetchSuccessCallback.bind(this), this.dataSourceOnErrorCallback.bind(this)),
        sortable: true,
        pageable: false,
        resizable: true,
        height: "90vh",
        toolbar: [{ name: "create", text: "Create New Flow" }],
        noRecords: {
          template: "No Flows."
        },
        columns: [{ field: "title", title: "Title", filterable: false, sortable: false, width: "8rem" }, { field: "flowType", title: "Flow Type", filterable: false, sortable: false, width: "4rem" }, { field: "flowStatus", title: "Flow Status", filterable: false, sortable: false, width: "4rem", template: function template(dataItem) {
            return "" + _this._getFlowStatusText(dataItem.flowStatus);
          } }, { title: "Update", command: [{ name: "edit", text: "Update" }], width: "4rem" }],
        editable: {
          mode: "popup",
          window: { title: "Update Bot Flow" },
          template: kendo.template($("#bot-manager-popup-editor").html())
        }
      };
    }
  }, {
    key: "applyFilters",
    value: function applyFilters() {
      this.gridOptions.dataSource.filter(this.filterService.getAppliedFilters());
    }
  }, {
    key: "dataSourceFetchSuccessCallback",
    value: function dataSourceFetchSuccessCallback(e) {
      this.botManagerMatchCount = this.gridOptions.dataSource.total();
      this.$scope.$apply();
    }
  }, {
    key: "dataSourceOnErrorCallback",
    value: function dataSourceOnErrorCallback(response) {
      alert(JSON.parse(response.xhr.responseText).message);
    }
  }, {
    key: "_getFlowStatusText",
    value: function _getFlowStatusText(type) {
      switch (type) {
        case _constants2.default.botFlowStatus.INACTIVE:
          return "Inactive";
        case _constants2.default.botFlowStatus.TEST:
          return "Test";
        case _constants2.default.botFlowStatus.LIVE:
          return "Live";
      }
    }
  }]);
  return BotManagerController;
}();

exports.default = BotManagerController;


/** WEBPACK FOOTER **
 ** ./client/app/containers/bot-manager/bot-manager.controller.js
 **/